import form from './form.ejs'
import align from './align.ejs'

export default { form, align }
